module.exports = __webpack_public_path__ + "img/hz2.83ca7fd3.png";